import React from 'react'


import Container from './Container'
import Footer from '../Footer/Footer'
import Navbar from '../navbar/Navbar'
import Stepper from './Stepper'

const About = () => {
  return (
    <div>
        <Navbar/>  
        <Container/>
        <Stepper/>
        <Footer/>
        
    </div>
  )
}

export default About